export default "__VITE_ASSET__$P4RZKht__"